import { cn } from '@forest/shared'
import type { JSX } from 'solid-js'
import { CloseButton } from '~/components/close-button'

/**
 * A paywall screen: the gradient page and its X, the content, and the footer
 * of actions held at the bottom edge while the content scrolls under it.
 */
export function Screen(props: {
  /** Spacing between the content's sections. */
  class?: string
  /** Replaces the X's default of closing the page. */
  onClose?: () => void
  footer: JSX.Element
  children: JSX.Element
}) {
  return (
    <div class="flex min-h-screen flex-col bg-paywall text-white">
      <CloseButton onClose={props.onClose} />
      <main
        class={cn(
          'mx-auto flex w-full max-w-[640px] flex-1 flex-col px-8 pb-12 pt-[120px]',
          props.class,
        )}
      >
        {props.children}
      </main>
      <footer class="sticky bottom-0 bg-[#01192b] px-6 pb-12 pt-4 shadow-[0_-2px_0_rgba(255,255,255,0.2)]">
        <div class="mx-auto flex max-w-[640px] flex-col items-center gap-4">
          {props.footer}
        </div>
      </footer>
    </div>
  )
}
